module.exports = __webpack_public_path__ + "static/media/6_1.f4ca6a78.jpg";